import { OptimisticMutationResolver } from '@urql/exchange-graphcache';

import {
  MgsaForEditorFragment,
  MgsaForEditorFragmentDoc,
} from '../fragments/generated/mgsaForEditor';
import { UpdateMgsaMutation, UpdateMgsaMutationVariables } from '../mutations/generated/updateMgsa';

const updateMgsa: OptimisticMutationResolver<
  UpdateMgsaMutationVariables,
  UpdateMgsaMutation['updateMgsa']
> = (variables, cache, info) => {
  const data = variables.data;
  const { entityId } = data;

  // mgsaForEditor is always null since we have not defined a key for MgsaType.
  // so optimistic update will not work as expected.
  // We are already using uncontrolled inputs in the Mgsa Editor,
  // which minimizes the need for optimistic updates here.
  const mgsaForEditor = cache.readFragment(MgsaForEditorFragmentDoc, {
    __typename: 'MgsaType',
    entityId: entityId,
  }) as MgsaForEditorFragment | null;

  if (!mgsaForEditor) {
    return {
      __typename: 'UpdateMgsaPayload',
      success: false,
      mgsa: null,
    };
  }

  const returnValue = {
    __typename: 'UpdateMgsaPayload',
    success: true,
    mgsa: {
      ...mgsaForEditor,
      entityId,
      draftState: data.draftState ?? mgsaForEditor.draftState,
    },
  };

  return returnValue;
};

export default updateMgsa;
